import { State } from 'src/types'
import { edgeOfCommon, edgeOfRegularBackStyle } from '../edge'
import { hamidashiOfMiddleFingerRegularBackStyle } from '../hamidashi'
import { indexFingerTipOutDrawer } from '../indexFingerTipOut'
import { littleFingerOfRegularBackStyle } from '../littleFinger'
import { regularBackStyleWristBelt } from '../regularBackWristBelt'
import { ringRightMiddleLeftFingerOfRegularBackStyle } from '../ringMiddleFinger'
import { thumbFingerOfRegularBackStyle } from '../thumbFinger'

export const regularStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State, printLeatherTypeValue?: string): Promise<void> => {
  const isRegularBack =
    [state?.backStyle?.value].includes('regularBackStyleCatcher') ||
    (state?.baseModel?.backStyle === 'regularBackStyleCatcher' && state?.backStyle?.value === 'unselected')
  if (!isRegularBack) return
  // 親指
  // 人差指
  // 中指右
  await thumbFingerOfRegularBackStyle(ctx, state?.thumbIndexMiddleRight?.color, state.stitch.color, printLeatherTypeValue)
  // 中指左
  // 薬指
  await ringRightMiddleLeftFingerOfRegularBackStyle(ctx, state?.middleLeftRing?.color, state.stitch.color, printLeatherTypeValue)
  // 小指袋
  await littleFingerOfRegularBackStyle(ctx, state.littleOut.color, state.stitch.color, printLeatherTypeValue)
  // ハミダシ
  hamidashiOfMiddleFingerRegularBackStyle(ctx, state.hamidashi)
  // ヘリ革
  edgeOfCommon(ctx, state.edge.color)
  edgeOfRegularBackStyle(ctx, state.edge.color, state.fingerGuardType.value, state.linings.color)
  // 人差し指の指だし周りパーツ部分
  await indexFingerTipOutDrawer(ctx, state?.indexFingerTipOut?.color, state.fingerGuardType.value, printLeatherTypeValue)
  // バックルベルト
  regularBackStyleWristBelt(ctx, state.listBelt.color, -70, 50)
}
